import React, { useState, useRef, useEffect } from 'react';
import { getTypes, createType, updateType, softDeleteType } from '../../Services/TypeService';
import { useForm, Controller } from 'react-hook-form';
import Swal from 'sweetalert2';
import MTable from '../../Components/MTable/MTable';
import { InputSwitch } from 'primereact/inputswitch';
import Overlay from '../../Components/Overlay/Overlay';
import { handlerFormError, uuid, upperFirstLetter, cleanString } from '../../Utils/Utils';
import EditButton from '../../Components/Button/EditButton';
import { useDispatch } from 'react-redux';
import { setModuleName } from '../../Stores/Action/AppAction';
import { Uploader } from 'rsuite';
import 'rsuite/dist/rsuite.min.css'

let processingId = -1;

const TypeScreen = () => {
    const mTable = useRef();
    const dispatch = useDispatch();
    const { register, handleSubmit, reset, setValue, control, formState: { errors } } = useForm({
        defaultValues: {
            type_code: '',
            type_name: '',
            type_extension: '',
            is_active: true
        }
    });

    const [isnotvalid, setIsNotValid] = useState(false);
    const [state, setState] = useState({
        showForm: false,
        type: {
            type_code: '',
            type_name: '',
            type_extension: '',
            fa_icon: '',
            is_active: true
        },
        file_icon: '',
        processing: false
    });

    const handleCodePaste = e => {
        const str = cleanString(e.target.value);
        const str2 = upperFirstLetter(str);
        setValue('type_code', str2.replace(/\s/g, ""))
    }

    const handleCodeInput = e => {
        const str = cleanString(e.target.value);
        const str2 = upperFirstLetter(str);
        setValue('type_code', str2.replace(/\s/g, ""))
    }

    useEffect(() => {
        dispatch(setModuleName('Asset Type'));
    }, []);

    const changeStatus = (username, status) => {
        const body = {
            is_active: status
        }

        softDeleteType(username, body, res => {
            if (res.status == 200 || res.status == 201) {
                Swal.fire({
                    icon: 'success',
                    title: 'Change status success',
                    text: 'Data has been changed!'
                }).then(res => { mTable.current.refresh(); });
            }
        }, error => {
            Swal.fire({
                icon: 'error',
                title: 'Change status fail',
                text: 'Data can not be changed!'
            });
        });
    }

    const columns = [
        {
            id: uuid(),
            title: 'Avatar',
            sortable: false,
            render: data => {
              return <div>{(data.thumbnail.preview_url != '' ?  <img src={process.env.REACT_APP_OBS_URL + data.thumbnail.preview_url} style={{ width: 32, height: 32, objectFit: 'cover' }} /> : '-')}</div>;
            },
        },
        {
            id: uuid(),
            title: 'Fa Icons',
            sortable: false,
            render: item => {
                return <div><span className={item.fa_icon}></span></div>;
            },
        },
        { id: uuid(), title: 'Type Code', field: 'type_code', sortable: true },
        { id: uuid(), title: 'Type Name', field: 'type_name', sortable: true },
        { id: uuid(), title: 'File Extension', field: 'type_extension', sortable: true },
        {
            id: uuid(),
            title: 'Active',
            field: 'is_active',
            sortable: true,
            options: [
              {
                label: 'Active',
                value: true
              },
              {
                label: 'Inactive',
                value: false
              }
            ],
            render: data => {
              return <InputSwitch checked={data.is_active} onChange={(e) => changeStatus(data._id, e.value)} />;
            },
        },
        {
            id: uuid(),
            title: 'Action',
            sortable: false,
            style: { width: 200 },
            render: item => {
                return (
                    <div>
                        <EditButton title="Edit" onClick={onEdit(item)} />
                    </div>);
            },
        },
    ];

    const propsTable = { columns, getData: getTypes, enableFilter: true, showAddButton: true, filterRule: 'filter' };


    const onEdit = item => () => {
        reset(item);
        setState({ ...state, type: item, showForm: true });
    }

    const onAddData = () => {
        onReset();
        setState({ ...state, showForm: true });
    }

    const startProcessing = () => {
        processingId = setTimeout(() => {
            setState({ ...state, processing: true });
        }, 150);
    }

    const stopProcessing = () => {
        clearTimeout(processingId);
        setState({ ...state, processing: false });
    }

    const iconUpload = e => {
        if (e.length > 0) {
            if(e[0].blobFile.size >= 500000 ){ //size in Byte
                Swal.fire({
                    icon: 'error',
                    title: 'Save data failed!',
                    text: 'Avatar file size exceed limit max 500Kb, [uploaded size is : '+ parseFloat(e[0].blobFile.size / 1000).toFixed(0) +'Kb] Pls remove manually'
                }).then(r => {
                    setState({ ...state, file_icon: ''});
                    setIsNotValid(true);
                })
            }else if (e[0].blobFile.type.toString() != 'image/png' && e[0].blobFile.type.toString() != 'image/gif' && e[0].blobFile.type.toString() != 'image/jpg' && e[0].blobFile.type.toString() != 'image/jpeg'){
                Swal.fire({
                    icon: 'error',
                    title: 'Save data failed!',
                    text: 'Avatar file type must png/gif/jpg/jpeg, Pls remove manually' 
                }).then(r => {
                    setState({ ...state, file_icon: ''});
                    setIsNotValid(true);
                })
            }else{
                setState({ ...state, file_icon: e[0].blobFile});
                setIsNotValid(false);
            }
        }
    }

    const iconRemove = e => {
        setState({ ...state, file_icon: '' });
        setIsNotValid(false);
    }

    const onSubmit = (data) => {
        startProcessing();
        const formData = new FormData();

        for (var key in data) {
            if(key == 'is_active'){
                var sta = data[key] === true ? 1 : 0;
                formData.append(key, sta);
            }else{
                formData.append(key, data[key]);
            }
            
        }

        formData.append('file_thumbnail', file_icon);

        if (type._id) {
            formData.append('_method', 'put');
        }

        const response = type._id ? updateType(type._id, formData) : createType(formData);
        response.then(res => {
            if (res.status == 200 || res.status == 201) {
                Swal.fire({
                    icon: 'success',
                    title: 'Save data success',
                    text: 'Data has been saved!'
                }).then(r => {
                    mTable.current.refresh();
                    type._id ? onCloseForm() : onReset();
                })
            }
        }).catch(({ response: { data } }) => {
            handlerFormError(data);
        }).finally(_ => stopProcessing());
    }

    const onReset = () => {
        reset({
            type_code: '',
            type_name: '',
            type_extension: '',
            file_icon: '',
            fa_icon: '',
            is_active: true,
            sort: 0
        });
        setState({ ...state, type: {}, file_icon: '' });
    }

    const onCloseForm = () => {
        reset({
            type_code: '',
            type_name: '',
            type_extension: '',
            file_icon: '',
            fa_icon: '',
            is_active: true,
            sort: 0
        });
        setState({ ...state, type: {}, showForm: false, file_icon: '' });
    }

    const { type, processing, showForm, file_icon } = state;

    return (
        <div className="content-wrapper">
            <div className="content-header">
            </div>
            <section className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className='col-md-12'>
                            <div className='card'>
                                <Overlay display={processing} />
                                <div className="card-header">
                                    <div className="card-title">
                                        <i className="fas fa-tags mr-1" />
                                        {showForm ? ' Form Asset Type' : ' List Asset Type'}
                                    </div>
                                </div>

                                <form name="form-detail" onSubmit={handleSubmit(onSubmit)}>
                                    <div className='card-body'>
                                        <div className={`${!showForm ? 'card__side--front-show' : 'card__side--front'}`}>
                                            <MTable ref={mTable} {...propsTable} onAddData={onAddData} showIndex={true} />
                                        </div>

                                        <div className={`${showForm ? 'card__side--back-show' : 'card__side--back'}`}>
                                            <div className='row'>
                                                <label htmlFor="type_code">Fields with <span className='mandatory'></span> are required.</label>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label htmlFor="type_code" className='mandatory'>Asset Type Code</label>
                                                        <input id="type_code" {...register("type_code", { required: { value: true, message: 'Asset type code is required!' } })} placeholder='Asset type code' readOnly={true} style={{ background: `#e9ecef` }} className='form-control' />
                                                        {errors.type_code && (<span className='text-danger' style={{ fontSize: 14 }}>{errors.type_code.message}</span>)}
                                                    </div>
                                                    <div className='form-group'>
                                                        <label htmlFor="type_name" className='mandatory'>Asset Type Name</label>
                                                        <input id="type_name" {...register("type_name", { required: { value: true, message: 'Asset type name is required!' } })} onPaste={handleCodePaste} onChange={handleCodeInput} placeholder='Asset type name' className='form-control' />
                                                        {errors.type_name && (<span className='text-danger' style={{ fontSize: 14 }}>{errors.type_name.message}</span>)}
                                                    </div>
                                                    <div className='form-group'>
                                                        <label htmlFor="fa_icon" className='mandatory'>Allowed File Extensions</label>
                                                        <textarea className="form-control" type="text" placeholder="Ex: jpg, mov, MOV, mp4, MP4 png, PNG.." name="type_extension" {...register("type_extension", { required: { value: true, message: 'File Extensions is required!' } })}/>
                                                        {errors.type_extension && (<span className='text-danger' style={{ fontSize: 14 }}>{errors.type_extension.message}</span>)}
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label htmlFor="fa_icon">Icon</label>
                                                        <input id="fa_icon" {...register("fa_icon")} placeholder='Font Awesome..' className='form-control' />
                                                        {errors.fa_icon && (<span className='text-danger' style={{ fontSize: 14 }}>{errors.fa_icon.message}</span>)}
                                                    </div>
                                                    <div className='form-group'>
                                                        <label htmlFor="category_icon" className='mandatory'>Images</label>
                                                        <div className='form-control'>
                                                            <div style={{ display: `inline-flex`} } >
                                                                {
                                                                    type._id && (
                                                                    <div className='form-control' style={{ marginRight: 10 }}>
                                                                        <img src= { process.env.REACT_APP_OBS_URL + type.thumbnail.preview_url } style={{ height: 64, objectFit: 'cover' }} />
                                                                    </div> )
                                                                }
                                                                <div className='form-control' style={{ marginRight: 10 }}>
                                                                    <Uploader
                                                                        name="file_icon"
                                                                        multiple={false}
                                                                        autoUpload={false}
                                                                        listType="picture"
                                                                        value={file_icon}
                                                                        onChange={e => iconUpload(e)}
                                                                        disabled={file_icon == '' ? false : true}
                                                                        onRemove={e => iconRemove(e)}
                                                                        action=''>
                                                                    </Uploader>
                                                                </div>
                                                            </div>
                                                            <span style={{ display: 'flex', color: 'darkgrey', fontSize: 10 }}>Resolusi: 1280 x 70 (min width 640 pixel), Format: JPG/PNG/GIF, Max: 500Kb</span>
                                                        </div>
                                                    </div>
                                                    <div className='form-group'>
                                                        <label htmlFor="is_active">Active</label>
                                                        <div>
                                                            <Controller name="is_active" control={control} render={({ field }) => { return (<InputSwitch {...field} checked={field.value} />) }} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {
                                        showForm && <div className='card-footer delay'>
                                            <div className='row'>
                                                <div className='col-md-12'>
                                                    <div className='d-flex' style={{ justifyContent: 'flex-end' }}>
                                                        <button type='button' className='btn btn-outline-dark mr-3' style={{ width: 100 }} onClick={onCloseForm}><i className='fa fa-times' /> Close</button>
                                                        <button type='button' className='btn btn-danger mr-3' style={{ width: 100 }} onClick={onReset}><i className='fa fa-sync' /> Clear</button>
                                                        <button type='submit' className='btn btn-dark' style={{ width: 100 }}
                                                        >
                                                            <i className='fa fa-save' /> Save</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </form>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default TypeScreen;